import React, { useState, useEffect } from 'react';
import Axios from "axios";
import ConsultantLayout from '../commonlayouts/consultantlayout';
import { Link, useNavigate } from 'react-router-dom';
import { GenerateContent, SendMailToLeads, UpdateLeadOutreachBulk } from '../apiconstants/constants';
import WYSIWYGEditor from "../helpers/WYSIWYGEditor";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const SelectedLeads = () => {
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const storedCandidates = JSON.parse(localStorage.getItem('selectedLeads') || '[]');
  const [isLoading, setIsLoading] = useState(false);
  const { register, reset, handleSubmit, control, formState: { errors, isSubmitting } } = useForm();
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false);
  const clientData = JSON.parse(localStorage.getItem("clientData"));
 const fileInputRef = React.useRef();
const [attachments, setAttachments] = useState([]);
   const [selectedCCEmail, setSelectedCCEmail] = useState("sales@knackhook.com");
const [previewHtml, setPreviewHtml] = useState("");
const [showPreview, setShowPreview] = useState(false);
    const email = localStorage.getItem("email")
      const guid = localStorage.getItem("guid")
        const mobileNumber = localStorage.getItem("mobileNumber");
     const firstName = localStorage.getItem("firstName") || "";
const lastName = localStorage.getItem("lastName") || "";
const token = localStorage.getItem('jwtToken');
// Concatenate with a space in between
const senderName = `${firstName} ${lastName}`.trim();

const handleFileChange = (e) => {
  const newFiles = Array.from(e.target.files);
  setAttachments(prev => [...prev, ...newFiles]);
};

const removeFile = (index) => {
  setAttachments(prev => prev.filter((_, i) => i !== index));
};


  useEffect(() => {
    if (storedCandidates) {
      setSelectedCandidates(storedCandidates);
    }
  }, []);

  const onSubmit = async (data, e) => {
    console.log(data);
    e.preventDefault();
    reset();
    setIsLoading(true);
    sendSelectedItemsToApi(data);
  }

const generatePreviewTemplate = (formData) => {
  const recipientsTable = selectedCandidates
    .map(c => `<tr>
      <td style="padding:4px; border:1px solid #ccc;">${c.fullName}</td>
      <td style="padding:4px; border:1px solid #ccc;">${c.email}</td>
    </tr>`)
    .join("");

  return `
    <div style="font-family: Arial, sans-serif; line-height: 1.6;">
      <p>Dear ${selectedCandidates[0]?.fullName || "Recipient"},</p>

      <div>${formData.content || ""}</div>

      <p style="margin-top:20px;">Best regards,<br/>
  <strong>${senderName || "KnackHook Sales Team " },</strong><br/>
      ✉️ ${email || "sales@knackhook.com"},<br/>
      📞 ${mobileNumber || ""}.</p>
     
    </div>
  `;
};
const getNextStage = (currentStage) => {
  if (!currentStage || currentStage.toLowerCase() === "null") return "Initial";

  switch (currentStage) {
    case "Initial":
      return "FollowUp-1";
    case "FollowUp-1":
      return "FollowUp-2";
    case "FollowUp-2":
      return "FollowUp-3";
    case "FollowUp-3":
      return "Closed"; // cap it here
    case "Engaged":
      return "Engaged"; // stays the same, no follow-up needed
    default:
      return "Initial"; // fallback
  }
};


const generateEmailWithGemini = async (lead, stage) => {
  try {
  setIsLoading(true);
//     if ((stage || "").toLowerCase() === "engaged") {
//   setIsLoading(false);
//   return {
//     subject: `Thank you, ${lead.fullName || "there"}!`,
//     body: `Hi ${lead.fullName || "there"},<br/><br/>
// Thank you for getting back to us. We truly appreciate your engagement and look forward to exploring how KnackHook can support your goals.<br/><br/>
// `
//   };
// }

    let stageInstructions = "";

    switch (stage ) {
      case "FollowUp-1":
        stageInstructions = `
This is the first follow-up email.
- Do not include "Hi" or "Dear" in the response (the greeting is handled separately).
- Start with a positive note about the company or domain.
- Gently remind them about your earlier email.
- Restate KnackHook’s core value in 2-3 lines.
- End with a polite call-to-action.`;
        break;

      case "FollowUp-2":
        stageInstructions = `
This is the second follow-up email.
- Do not include "Hi" or "Dear" in the response (the greeting is handled separately).
- Start with a positive note about the company or domain.
- Gently remind them about your earlier email.
- Mention KnackHook again but highlight NEW value (success story, benefit, metric).
- Emphasize KnackHire and KnackVibes in 2-3 lines.
- Invite them again to connect.`;
        break;

      case "FollowUp-3":
        stageInstructions = `
This is the third follow-up email.
- Do not include "Hi" or "Dear" in the response (the greeting is handled separately).
- Start with a positive note about the company or domain.
- Gently remind them about your earlier email.
- Acknowledge no response so far.
- Keep it short and respectful.
- Offer to close the loop if there’s no interest, but leave the door open.`;
        break;

      default:
        stageInstructions = `
This is the initial outreach email.
- Do not include "Hi" or "Dear" in the response (the greeting is handled separately).
- Start with a positive note about the company or domain.
- Add 2–3 lines of admiration about their company/domain (if available).
- Introduce KnackHook (AI/ML + full-stack teams) in 3 lines.
- Mention KnackHire (AI-powered staffing) and KnackVibes (digital brand growth helping companies cut hiring cycles and accelerate market presence.) in 3 lines.
- Keep it professional, short, and conversational.
- End with a clear call-to-action about exploring collaboration.`;
    }

    const response = await Axios.post(
      GenerateContent.APIURL,
      {
       prompt: `
You are an email generation assistant.  
Generate a ${stage} outreach email with **two fields only**:  
1. "subject" → a short, engaging subject line.  
2. "body" → the email body (2–5 sentences, HTML allowed).  

Lead details:  
- First Name: ${lead.fullName || "there"}  
- Company: ${lead.companyName || "the company"}  
- Domain/Description: ${lead.domain || "working on GTM and AI"}  

Guidelines:  
${stageInstructions}  
⚠️ IMPORTANT:  
- The body **must always begin with this line as the very first sentence**:  
  "Greetings from KnackHook, Hope you are doing well!"  
- After that, add: "We are excited to explore potential collaboration opportunities with you."  
- Then continue with the rest of the email following the stage-specific guidelines.  

Service Mapping Logic:  
- If the lead’s domain/description suggests recruiter, talent acquisition, staffing, or bench sales → Focus on KnackHook’s Staffing & Augmentation services with KnackHire AI powered tool (automated resume screening, candidate shortlisting, transparent results sharing, staffing services across US and India markets).  
- If the lead’s domain/description suggests product owner, technical lead, engineering manager, or other tech leadership roles → Focus on KnackHook’s Application Development expertise (enterprise apps, end-to-end solutions).  
- If the lead’s domain/description suggests AI/ML, innovation, or automation → Focus on KnackHook’s AI Solutions (AI/ML development, responsible AI, agentic systems).  
- If the lead’s domain/description suggests analytics, data, or BI → Focus on KnackHook’s Data Analytics & Engineering services (ETL, pipelines, dashboards, insights).  

The output must be **valid JSON only**, no extra text, in the following format:  
{
  "subject": "Your subject here",
  "body": "Your email body here"
}
`

      },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const raw = response.data?.response?.candidates?.[0]?.content?.parts?.[0]?.text || "";

let subject = "Let's connect";
let body = "";

try {
  // Gemini might wrap JSON with code fences or spaces
  const clean = raw.trim().replace(/```json|```/g, "");
  const parsed = JSON.parse(clean);

  subject = parsed.subject || subject;
  body = parsed.body || raw;
} catch {
  // fallback: if AI didn’t return JSON, use raw text as body
  body = raw;
}
setIsLoading(false);
return { subject, body };

  } catch (err) {
    setIsLoading(false);
    console.error("Error generating email:", err);
    return {
      subject: "Let's connect",
      body: `Hi ${lead.fullName || "there"},<br/><br/>I’d love to explore how KnackHook can support your team with AI-driven product development, staffing (KnackHire), and brand growth (KnackVibes).<br/><br/>
<p style="margin-top:20px;">
  Best regards,<br/>
  <strong>${senderName || "KnackHook Sales Team " }</strong><br/>
  ✉️ ${email || "sales@knackhook.com"}<br/>
  📞 ${mobileNumber || ""}
</p>`,
    };
  }
};


useEffect(() => {
  const generateemail = localStorage.getItem("aimail");
  const storedCandidates = JSON.parse(localStorage.getItem('selectedLeads') || '[]');

  if (generateemail === "true" && storedCandidates.length > 0) {
    const firstCandidate = storedCandidates[0];
const stage = getNextStage(firstCandidate.currentStage);
generateEmailWithGemini(firstCandidate, stage).then(({ subject, body }) => {
  reset({ subject, content: body });
});

    generateEmailWithGemini(firstCandidate, stage).then(({ subject, body }) => {
      reset({
        subject,
        content: body
      });
    });
  } else {
    reset({ subject: "", content: "" });
  }
}, []);

  
  const sendSelectedItemsToApi = async (data) => {
  setIsLoading(true);

  // Prepare the leads JSON string
  const leads = selectedCandidates.map(candidate => ({
    leadId:candidate.id,
    name: candidate.fullName,
    email: candidate.email
  }));

  const formData = new FormData();
  formData.append("CompanyName", clientData?.companyName || "");
  formData.append("LogoUrl", clientData?.logoURL || "");
  formData.append("Subject", data.subject);
  formData.append("Content", data.content);
  formData.append("LeadsJson", JSON.stringify(leads)); // Use LeadsJson instead of leads
  formData.append("FromMail", email || "");
  formData.append("CCmail", selectedCCEmail||"sales@knackhook.com");
  formData.append("Phonenumber", mobileNumber || "");
  formData.append("UserGuid", guid);
  formData.append("Guid", guid);
  formData.append("senderName", senderName);
  attachments.forEach(file => {
    formData.append("attachments", file); // Keep key name as 'attachments'
  });

  try {
    const result = await Axios.post(SendMailToLeads.APIURL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`,
      }
    });

    setIsLoading(false);

    if (result.data === 'Emails sent successfully to all leads.') {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Sent Successfully',
        showConfirmButton: false,
        timer: 5000
      });
      const payload = {
        leadId: selectedCandidates.map(c => c.id), // Collect all sent leads' IDs
        userGuid: guid
      };

      try {
        const saveResult = await Axios.post(UpdateLeadOutreachBulk.APIURL, payload,
          { headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            }
          }
        );
        console.log("✅ Bulk API response:", saveResult.data);
      } catch (saveError) {
        console.error("❌ Error calling bulk API:", saveError);
      }

       localStorage.removeItem("aimail");
      navigate("/Employer/ListOfLeads");
    } else {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Add correct Details',
        showConfirmButton: false,
        timer: 5000
      });
    }
  } catch (error) {
    console.error("Error", error);
    setIsLoading(false);
  }
};

  return (
    <ConsultantLayout>
      {isLoading ? <center><LoadingSpinner /></center> :
        <div className='container-fluid mt-3'>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/Employer/ListOfLeads">
              <i className="fa fa-arrow-left" onClick={() => {
    localStorage.removeItem("aimail");
    navigate("/Employer/ListOfLeads");
  }} style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
            </Link>
            <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Selected Leads</h2>
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>Full Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {selectedCandidates.map(item => (
                <tr key={item.id}>
                  <td>{item.fullName}</td>
                  <td>{item.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <form onSubmit={handleSubmit(onSubmit)} id="loginform">
            <div>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Subject</Tooltip>)}>
                <input type="text" title='' placeholder='Subject' {...register("subject", { required: "Subject Required" })} id="subject" name="subject"
                  disabled={isDisabled} className={`form-control basic-form mt-3 ${errors.subject ? 'is-invalid' : ''}`}
                />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.subject?.message}</div>
            </div>
            <input
  type="text"
  {...register("emailCC")}
  className="form-control basic-form mt-3"
  placeholder="CC Email"
  value={selectedCCEmail}
  onChange={(e) => setSelectedCCEmail(e.target.value)}
/>
            <div>
              <label style={{ color: "#00a7ac", marginTop: 10 }}>Content</label>
              <Controller
                control={control}
                name="content"
                rules={{
                  required: { value: true, message: "Content Required" },
                }}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <div>
                    <WYSIWYGEditor
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      ref={ref}
                      inputExtraProps={{
                        required: true,
                      }}
                    />
                    {errors.content && (
                      <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                        {errors.content.message}
                      </p>
                    )}
                  </div>
                )}
              />
            </div>
           <div className="mt-3">
  {/* <label style={{ color: "#00a7ac" }}>Attachments</label> */}
  <div
    style={{
      // border: "1px dashed #ccc",
      padding: 10,
      borderRadius: 6,
      cursor: "pointer",
      display: "inline-block",
       color: "#00a7ac"  
    }}
    onClick={() => fileInputRef.current.click()}
  >
    <i className="fas fa-paperclip" style={{ marginRight: 6,color: "#00a7ac"  }}></i> Attach files
  </div>
  <input
    type="file"
    ref={fileInputRef}
    style={{ display: "none" }}
    multiple
    onChange={handleFileChange}
  />
</div>
{attachments.length > 0 && (
  <div className="mt-2">
    {attachments.map((file, index) => (
      <div
        key={index}
        style={{
          background: "#f1f1f1",
          padding: "6px 10px",
          borderRadius: 4,
          marginBottom: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}
      >
        <span>
          <i className="fas fa-file" style={{ marginRight: 8 }}></i>
          {file.name} ({Math.round(file.size / 1024)} KB)
        </span>
        <button
          type="button"
          className="btn btn-sm btn-link text-danger"
          onClick={() => removeFile(index)}
        >
          <i className="fas fa-times"></i>
        </button>
      </div>
    ))}
  </div>
)}


      <div className="row mb-4 mt-3"> 
  <div className="col-12 d-flex justify-content-end gap-2 mb-3 mt-5">

    {/* Preview Button */}
    <button
      type="button"
      className="btn btn-primary"
      onClick={handleSubmit((formData) => {
        const html = generatePreviewTemplate(formData);
        setPreviewHtml(html);
        setShowPreview(prev => !prev); // toggle
      })}
    >
      {showPreview ? "Hide Preview" : "Preview Email"}
    </button>

    {/* Send Email Button */}
    <button
      id="svbutton"
      disabled={isSubmitting || isDisabled}
      className="btn btn-primary"
    >
      Send Email
    </button>

    {/* Cancel Button */}
    <Link to="/Employer/ListOFLeads">
      <button className="btn btn-primary">
        Cancel
      </button>
    </Link>

  </div>
</div>


          </form>
         
          {showPreview && (
  <div className="card mt-4 p-3" style={{ border: "1px solid #ccc", fontSize: 14 }}>
    <h4>Email Preview</h4>
    <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
  </div>

)}

        </div>
      }
    </ConsultantLayout>
  );
}

export default SelectedLeads;
